import { render, staticRenderFns } from "./loc-type-cards3.vue?vue&type=template&id=191636ac&scoped=true"
import script from "./loc-type-cards3.vue?vue&type=script&lang=js"
export * from "./loc-type-cards3.vue?vue&type=script&lang=js"
import style0 from "./loc-type-cards3.vue?vue&type=style&index=0&id=191636ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191636ac",
  null
  
)

export default component.exports